module.exports = __webpack_public_path__ + "static/media/Soundcloud_horizontal.d11c3284.svg";